import { ColoredIcon } from "@msuite/ui/icons";
import { Tooltip } from "@msuite/ui/tooltip";
import type { ClassNameProps } from "@msuite/ui/types";
import { cn } from "@msuite/ui/utils";
import type { Tables } from "@msuite/utils/types";
import { useTableTypes } from "@/hooks/use-table-types";

/** Props Interface */
interface TicketTypeIconProps extends ClassNameProps {
	ticketTypeId: string;
	/**
	 * The type row itself, when the caller already holds it. A ticket synced through the board
	 * queries brings its type along, and on a guest board that is the host's type — which the
	 * viewer's own catalogue, the lookup below, never holds.
	 */
	ticketType?: Pick<Tables<"ticketTypes">, "name" | "icon" | "color"> | null;
	withLabel?: boolean;
}

export function TicketTypeIcon({
	ticketTypeId,
	ticketType,
	withLabel = false,
	className,
}: TicketTypeIconProps) {
	/** Hooks */
	const { data } = useTableTypes("ticketTypes", ["active", "inactive"]);
	const type = ticketType ?? data?.tableTypes.find((type) => type.id === ticketTypeId);

	/** Render */
	return (
		<div className={cn("h-stack", className)}>
			<Tooltip label={type?.name}>
				<ColoredIcon
					iconName={type?.icon}
					color={type?.color}
				/>
			</Tooltip>
			{withLabel && <p className="text-sm">{type?.name}</p>}
		</div>
	);
}
